
const ko = require('knockout');
const $ = require('rgs-jquery');

const SinglePromiseQueue = require('promise-util').SinglePromiseQueue;

function makeMatcher (params) {
	params = $.extend({
		// jQuery element to search for matches in
		wrapper: null,
		// "Selector" for children in one of following notations:
		// * String selector with "{0}" placeholder for value
		// * Array of value-selector pairs
		// * Object of value-selector pairs
		children: null,
	}, params);

	if (!$.isArray(params.children) && 'object' == typeof params.children) {
		// `children' is specified as an object of value-element pairs
		// coerce it to the array-of-pairs notation
		params.children = $.map(params.children, function (el, val) {
			return [[val, el]];
		});
	}

	if ($.isArray(params.children)) {
		// `children' is specified as an array of value-element pairs
		return function (value) {
			let matched = $(),
				mismatched = $();

			if (value == null) {
				$.map(params.children, function (pair) {
					const el = pair[1];
					mismatched = mismatched.add(
						(el instanceof $) ? el : params.wrapper.children(el)
					);
				});
			} else {
				const valueIsString = 'string' === typeof value;
				$.map(params.children, function (pair) {
					let val = pair[0],
						el = pair[1];

					if (valueIsString) {
						// when comparing with string coerce everything to string
						// (useful with object-of-pairs notation)
						val = String(val);
					}

					if (value === val) {
						matched = matched.add(
							(el instanceof $) ? el : params.wrapper.children(el)
						);
					} else {
						mismatched = mismatched.add(
							(el instanceof $) ? el : params.wrapper.children(el)
						);
					}
				});
			}

			return { matched: matched, mismatched: mismatched };
		};
	} else if ('string' == typeof params.children) {
		// `children' is specified as selector pattern
		return function (value) {
			let matched = $(),
				mismatched = $();

			if (value == null) {
				mismatched = params.wrapper.children();
			} else {
				value = String(value);
				const match = params.children.replace('{0}', value);
				params.wrapper.children().each(function (i, elem) {
					elem = $(elem);
					if (elem.is(match)) {
						matched = matched.add(elem);
					} else {
						mismatched = mismatched.add(elem);
					}
				});
			}

			return {mismatched: mismatched, matched: matched};
		};
	}
	throw new TypeError("Invalid 'children' argument type");
	
}

ko.bindingHandlers.selectVisibleChild = (function (){
	var animations = {
		none: function (opts) {
			opts.wrapper.show().height('auto');
			opts.mismatched.hide();
			opts.matched.show();
			return $.when();
		},
		replaceBlocks: function (opts) {
			let wrapper = opts.wrapper,
				toBeHidden = opts.mismatched,
				toBeShown = opts.matched,
				newHeight = toBeShown.outerHeight() || 0;

			if (!wrapper.parent().is(':visible')) {
				// When `wrapper.parent()' is not ':visible' jquery can't
				// determine the new height correctly. Since parent is not
				// visible no one will care for the animation anyway.
				return animations.none(...arguments);
			}

			const wrapperAnimation = function () {
				return wrapper
					.height(wrapper.height())
					.animate({
						height: newHeight,
					}, {
						duration: 1000,
						complete: function () {
							wrapper.height('auto');
						},
						step: function (now, fx) {
							// Always set target height to the height of content to be shown
							// in case the content is also animated
							const h = toBeShown.outerHeight();
							if (h != null) {
								fx.end = h;
							}
						},
					}).promise();
			};
			const hideAnimation = function () {
				return toBeHidden.fadeOut(500).promise();
			};
			const showAnimation = function () {
				return toBeShown.fadeIn(500).promise();
			};
			const hideShowAnimation = function () {
				const dfr = $.Deferred();
				hideAnimation().then(showAnimation).done(function () {
					dfr.resolve();
				}).fail(function () {
					showAnimation().always(function () {
						dfr.resolve();
					});
				});
				return dfr;
			};

			return $.when(
				wrapperAnimation({
					wrapper: wrapper,
					newHeight: newHeight,
				}),
				hideShowAnimation()
			);
		},
		fioReplaceBlocks: function (opts) {
			let wrapper = opts.wrapper,
				hideRegion = opts.mismatched,
				showRegion = opts.matched;

			if (showRegion.is(':visible') && !hideRegion.is(':visible')) {
				return $.when();
			}
			const wrapperAnimation = function () {
				wrapper.height(wrapper.height());
				return wrapper.animate({
					height: showRegion.outerHeight(),
				}, {
					duration: 0,
					complete: function () {
						wrapper.height('auto');
					},
				}).promise();
			};

			const hideAnimation = function () {
				return hideRegion.fadeOut(500).promise();
			};
			const showAnimation = function () {
				return showRegion.fadeIn(500).promise();
			};

			return $.when(
				wrapperAnimation(),
				hideAnimation().then(showAnimation, showAnimation)
			);
			
		},
	};

	return {
		init: function (wrapper, valueAccessor) {
			const params = $.extend({}, {
				children: {}, // value -> child selector
				// Or a selector with special '{0}' substr to be replaced
				// with the value of observable.
				observable: null, // observable whose value determines visible children
				animation: 'replaceBlocks', // or false-ish to disable animation
				wrapper: wrapper,
			}, valueAccessor());

			wrapper = params.wrapper = $(params.wrapper);

			const animationsQueue = new SinglePromiseQueue();

			const matcher = makeMatcher(params);
			const observer = function (value, obsParams) {
				obsParams = obsParams || {};

				const matchedMismatched = matcher(value);

				const animation = function () {
					return $.when(
						animations[obsParams.animation || params.animation || 'none']({
							mismatched: matchedMismatched.mismatched,
							matched: matchedMismatched.matched,
							wrapper: wrapper,
						})
					);
				};

				animationsQueue.enqueue(animation);
			};

			let initRun = true;
			ko.computed(function () {
				observer(
					ko.unwrap(valueAccessor().observable),
					initRun ? { animation: 'none' } : null // no animation on init
				);
				initRun = false;
			}, null, { disposeWhenNodeIsRemoved: wrapper });
		},
	};
}());

// DEPRECATED: Use `ko-component-btn-radio-group` instead
ko.bindingHandlers.valueSelectButtonGroup = {
	init: function (group, valueAccessor) {
		console.warn('`valueSelectButtonGroup` binding is deprecated, '
					 + 'use `ko-component-btn-radio-group` component instead');

		const params = $.extend({}, {
			children: {}, // value -> button selector
			observable: null,
			wrapper: group,

			// if true, second click on the active button will set `observable` to `undefined`
			toggle: false,
		}, valueAccessor());

		group = params.wrapper = $(group);

		function makeClickHandler (val) {
			return function () {
				if (ko.unwrap(params.toggle)) {
					const currentVal = params.observable();
					if (currentVal === val) {
						params.observable(undefined);
					} else {
						params.observable(val);
					}
				} else {
					params.observable(val);
				}
			};
		}

		// Register click handlers
		if ($.isArray(params.children)) {
			$.map(params.children, function (pair) {
				let val = pair[0],
					btn = pair[1];
				group.on('click', btn, makeClickHandler(val));
			});
		} else {
			$.each(params.children, function (val, btn) {
				group.on('click', btn, makeClickHandler(val));
			});
		}

		const matcher = makeMatcher(params);
		const observer = function (value) {
			const matchedMismatched = matcher(value);
			matchedMismatched.matched.addClass('active');
			matchedMismatched.mismatched.removeClass('active');
		};

		params.observable.subscribe(observer);
		observer(params.observable());
	},
};
